<div>
  <div class="logo m-5 pointer" (click)="navigateToMainPage()"></div>
  <div class="p-x-6">
    @for (menuItem of menuItems(); track menuItem) {
      <lbt-menu-item
        routerLinkActive
        #rla="routerLinkActive"
        class="m-b-3"
        [matTooltip]="menuItem.title"
        matTooltipPosition="right"
        [routerLink]="menuItem.route"
        [title]="menuItem.title"
        [icon]="menuItem.icon"
        [active]="rla.isActive"
      />
    }
  </div>
</div>
<div class="p-6">
  <lbt-menu-item
    matTooltip="Sign out"
    matTooltipPosition="right"
    title="Logout"
    icon="logout"
    (click)="logout()"
  />
</div>

<ng-template #signOutTmpl>
  <lbt-confirmation
    okText='Sign out'
    okType='primary'
    title="Sign out of your account?"
    [showHeader]="true"
    [showCloseIcon]="false"
    [noDivider]="true"
    [confirmContent]='signOutTextTmpl'>
  </lbt-confirmation>
</ng-template>

<ng-template #signOutTextTmpl>
  <lbt-text typography="body1" color="gray-12">
    You’ll be signed out from your account on this device.
  </lbt-text>
</ng-template>
